
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/cc1-pro",
      function () {
        return require("private-next-pages/products/cc1-pro/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/cc1-pro"])
      });
    }
  